/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function EditarNivel(e) {
  let t = (0, ReactCompiler.c)(27),
    { nivel: n, onGuardar: r } = e,
    [i, a] = (0, React.useState)(n.nivel),
    o;
  t[0] === i
    ? (o = t[1])
    : ((o = i.trim().toUpperCase()), (t[0] = i), (t[1] = o));
  let s = o !== n.nivel,
    c = `border-b border-(--border) last:border-0 ${n.activo ? `` : `opacity-60`}`,
    l = `Nivel de ${n.subgrupo}`,
    u;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = (e) => a(e.target.value)), (t[2] = u))
    : (u = t[2]);
  let f;
  t[3] !== l || t[4] !== i
    ? ((f = (
        <td
          className={`px-3 py-1.5`}
          children={
            <input
              aria-label={l}
              className={`${Lo} min-h-10 w-32 uppercase`}
              value={i}
              maxLength={40}
              onChange={u}
            />
          }
        />
      )),
      (t[3] = l),
      (t[4] = i),
      (t[5] = f))
    : (f = t[5]);
  let p;
  t[6] === n.subgrupo
    ? (p = t[7])
    : ((p = (
        <td className={`px-3 py-1.5 text-(--text-h)`} children={n.subgrupo} />
      )),
      (t[6] = n.subgrupo),
      (t[7] = p));
  let m;
  t[8] !== s || t[9] !== n || t[10] !== r || t[11] !== i
    ? ((m = s && (
        <AccionAsync
          variante={`chico`}
          className={`mr-2 min-h-10`}
          onClick={() =>
            r(
              n.id,
              {
                ...n,
                nivel: i,
              },
              `Nivel guardado`,
            )
          }
          children={`Guardar`}
        />
      )),
      (t[8] = s),
      (t[9] = n),
      (t[10] = r),
      (t[11] = i),
      (t[12] = m))
    : (m = t[12]);
  let h;
  t[13] !== n || t[14] !== r
    ? ((h = () =>
        r(
          n.id,
          {
            ...n,
            activo: !n.activo,
          },
          n.activo ? `Subgrupo desactivado` : `Subgrupo activado`,
        )),
      (t[13] = n),
      (t[14] = r),
      (t[15] = h))
    : (h = t[15]);
  let _ = n.activo ? `Desactivar` : `Activar`,
    v;
  t[16] !== h || t[17] !== _
    ? ((v = (
        <AccionAsync
          variante={`texto`}
          className={`min-h-10`}
          onClick={h}
          children={_}
        />
      )),
      (t[16] = h),
      (t[17] = _),
      (t[18] = v))
    : (v = t[18]);
  let y;
  t[19] !== v || t[20] !== m
    ? ((y = (
        <td
          className={`px-3 py-1.5 text-right whitespace-nowrap`}
          children={[m, v]}
        />
      )),
      (t[19] = v),
      (t[20] = m),
      (t[21] = y))
    : (y = t[21]);
  let b;
  return (
    t[22] !== y || t[23] !== c || t[24] !== f || t[25] !== p
      ? ((b = <tr className={c} children={[f, p, y]} />),
        (t[22] = y),
        (t[23] = c),
        (t[24] = f),
        (t[25] = p),
        (t[26] = b))
      : (b = t[26]),
    b
  );
}
